import axios from 'axios';
import { trimTrailingSlash } from './biosdkRoutes';

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      const comma = String(dataUrl).indexOf(',');
      resolve(comma >= 0 ? String(dataUrl).slice(comma + 1) : String(dataUrl));
    };
    reader.onerror = () => reject(reader.error || new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });

export const buildFaceAdvancedBaseUrl = (biosdkBaseUrl) =>
  `${trimTrailingSlash(biosdkBaseUrl)}/face`;

/**
 * POST /face/extract-fused-template — K images → one BCHQ template.
 */
export async function extractFusedFaceTemplate(biosdkBaseUrl, files, options = {}) {
  if (!files?.length) throw new Error('At least one image is required for fused extract.');
  const images_b64 = await Promise.all(files.map((f) => fileToBase64(f)));
  const url = `${buildFaceAdvancedBaseUrl(biosdkBaseUrl)}/extract-fused-template`;
  const payload = {
    images_b64,
    model_name: options.modelName || 'buffalo_l',
    nist_mode: Boolean(options.nistMode),
    role: options.role ?? 0,
  };
  const response = await axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } });
  return response.data;
}

/**
 * POST /face/extract-group-faces — one group photo → M BCHQ templates.
 */
export async function extractGroupFaceTemplates(biosdkBaseUrl, file, options = {}) {
  if (!file) throw new Error('Group photo image is required.');
  const image_b64 = await fileToBase64(file);
  const url = `${buildFaceAdvancedBaseUrl(biosdkBaseUrl)}/extract-group-faces`;
  const payload = {
    image_b64,
    model_name: options.modelName || 'buffalo_l',
    nist_mode: Boolean(options.nistMode),
    role: options.role ?? 0,
  };
  const response = await axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } });
  return response.data;
}

export function templateB64ToBlob(templateB64) {
  const binary = atob(templateB64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: 'application/octet-stream' });
}
